import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';


const StyledIntroduction = styled(Box)(({ theme }) => ({

    width: '100%',
    minHeight: '100vh',
    overflow: 'hidden',
    padding: '0 5%',
    // backgroundColor: '#fff',
    // position: 'relative',
    background: 'transparent',
    '& ul': {
        listStyle: 'none', /* Removes bullets */
        padding: 15, /* Removes default padding */
        margin: 0, /* Removes default margin */
    },

    // background: theme.palette.background.secondary,
    '& .fadein': {
        opacity: 1,
        transition: 'opacity .8s ease-in-out,',
    },
    '& .fadeout': {
        opacity: 0,
        transition: 'opacity .8s ease-in-out',
    },

    '& .iconLogo': {
        width: 'auto',
        height: '100px',
        marginBottom: '10px',
    },
    '& .introductionBg': {
        position: 'absolute',
        height: '100%',
        width: '100%',

        '& .videoElement': {
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            objectFit: 'cover',
            zIndex: -1,
        },
    },

    '& .introductionContent': {
        position: 'absolute',
        height: '100%',
        width: '100%',
        zIndex: 1 /* Ensures content is above the video */,
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',

        '& .introductionText': {
            color: '#FFFFFF',
            textAlign: 'center',
            fontStyle: theme.typography.h3.fontStyle,
            fontVariant: theme.typography.h3.fontVariant,
            fontSize: theme.typography.h3.fontSize,
            fontWeight: 500,
            lineHeight: '37px',
            '& .bold': {
                fontWeight: '800',
            },
            '& .style': {
                fontStyle: 'italic',
                fontWeight: '600',
                '& span': {
                    position: 'relative',
                    display: 'inline-block',
                    background:
                        'linear-gradient(262.31deg, #14FF00 0%, #CCFF00 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))',
                    '-webkit-background-clip': 'text',
                    '-webkit-text-fill-color': 'transparent',
                },
                '& span::after': {
                    content: `''`,
                    position: 'absolute',
                    left: '0',
                    right: '0',
                    bottom: '0',
                    height: '2px',
                    background:
                        'linear-gradient(262.31deg, #14FF00 0%, #CCFF00 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))' /* Gradient colors */,
                    borderRadius: '2px',
                },
            },
        },

        '& .sectionTitle': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '30px 0px 5px',
        },
        '& .spanTextGradient': {
            background:
                'linear-gradient(262.31deg, #14FF00 0%, #CCFF00 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))',
            color: 'transparent',
            WebkitBackgroundClip: 'text',
            fontStyle: theme.typography.title.fontStyle,
            fontVariant: theme.typography.title.fontVariant,
            fontSize: theme.typography.title.fontSize,
            fontWeight: `${700} !important`,
        },
    },

    [theme.breakpoints.down('lg')]: {
        minHeight: '70vh',
        // marginTop: '-119px',

        '& .blobs': {
            width: '30vh',
            height: '30vh',

            '& .blob': {
                width: '70%',
                height: '70%',
            },
        },

        '& .introductionText': {
            fontStyle: `${theme.typography.h5.fontStyle} !important`,
            fontVariant: `${theme.typography.h5.fontVariant} !important`,
            fontSize: `${theme.typography.h5.fontSize} !important`,
            fontWeight: `${500} !important`,
        },

        '& .spanTextGradient': {
            fontStyle: `${theme.typography.h2.fontStyle} !important`,
            fontVariant: `${theme.typography.h2.fontVariant} !important`,
            fontSize: `${theme.typography.h2.fontSize} !important`,
            fontWeight: `${700} !important`,
        },
        '& .iconLogo': {
            width: '300px',
            height: '50px',
        },
    },
}));

export default StyledIntroduction;
